import {
  TargetResourceAdapterInteface,
  ListTargetResourcesInput,
} from 'src/adapter/TargetResourceAdapterInterface';
import { TargetResourceGetAttributes } from 'src/models/TargetResourceModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosTargetResourceAdapter
  implements TargetResourceAdapterInteface
{
  async listTargetResources(
    enquete_id: string,
    conditions?: ListTargetResourcesInput
  ): Promise<{ total: number; data: TargetResourceGetAttributes[] }> {
    try {
      const res = await api.get(
        `/enquetes/${enquete_id}/target-resources-contain-answers`,
        {
          params: conditions,
        }
      );
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getTargetResource(
    enquete_id: string,
    id: string
  ): Promise<TargetResourceGetAttributes> {
    try {
      const res = await api.get(
        `/enquetes/${enquete_id}/target-resources-contain-answers/${id}`
      );
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
